import { createSlice } from "@reduxjs/toolkit";

export const showSideBarSlice = createSlice({
  name: "showSideBar",
  initialState: {
    value: false,
  },
  reducers: {
    toggle: (state) => {
      state.value = !state.value;
    },
  },
});

// Action creators are generated for each case reducer function
export const { toggle } = showSideBarSlice.actions;

export default showSideBarSlice.reducer;
